import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { profileData } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 px-6 bg-gray-50 dark:bg-gray-800/50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 opacity-0 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            About Me
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="space-y-8">
          <div className="bg-white dark:bg-gray-900 rounded-3xl p-8 md:p-12 shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 opacity-0 animate-fadeInUp animation-delay-200">
            <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
              {profileData.about.summary}
            </p>
            <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
              {profileData.about.philosophy}
            </p>
            <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
              {profileData.about.interests}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {profileData.about.highlights.map((highlight, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-900 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 opacity-0 animate-fadeInUp"
                style={{ animationDelay: `${400 + index * 100}ms` }}
              >
                <div className="flex items-start space-x-3">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-1" />
                  <p className="text-gray-700 dark:text-gray-300">{highlight}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;